import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { listLocationsLinear } from '../Api'

export default generateApiAction({
  baseType: Types.LOCATIONS.LIST.LINEAR,
  api: listLocationsLinear,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/locations/ListLinearAction.js